import type { StateTree } from '@makemydeal/dr-dash-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import type { SalesCheckinRootState } from '../common/types/SalesCheckinRootState';

export const isMultiScenarioOfferEnabled = (state: SalesCheckinRootState): boolean =>
    featureToggleSelectors.isMultiScenarioOfferEnabled(state as unknown as StateTree);
